import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface SettingsState {
  language: string;
  hapticsEnabled: boolean;
}

const initialState: SettingsState = {
  language: 'en',
  hapticsEnabled: true,
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setLanguage(state, action: PayloadAction<string>) {
      state.language = action.payload;
    },
    setHapticsEnabled(state, action: PayloadAction<boolean>) {
      state.hapticsEnabled = action.payload;
    },
  },
});

export const { setLanguage, setHapticsEnabled } = settingsSlice.actions;
export default settingsSlice.reducer;
